

function LeadershipTier18DesignTemplate() {
    return (
        <div>
            <hr className="HorizontalLineBlue" />
            <b className="AbilityHeader animationcolorWhiteOrangeFlashing">DESIGN INSIGHTS</b>
            <hr className="HorizontalLineBlue" />
            <div className="animationFadeIn">
                While smple, this Talent provides a dramatic increase in the player's battlefield presence.
                <br />
                It also increases the player's flexibility as they can potentially use their Bonus Action for a
                different option such as casting a spell.
            </div>
            <p>
                <b className="AbilityHeaderSmall">WHY CAN'T YOU USE THE SAME COMMAND TWICE?</b>
                <div className="animationFadeIn">
                    Commands are extremely powerful, and stacking them would be significantly out of the power scope for the system.
                    <br />
                    This also encourages the player to use a variety of Commands, improving their decision making opportunities.
                    <br />
                    This is an example of designing so that players do not optimize their own fun out of the game.
                </div>
            </p>
            <p>
                <b className="AbilityHeaderSmall">THEMING</b>
                <div className="animationFadeIn">
                    In Chess, a Checkmate is when one player's King is threatened by the opposing players'
                    pieces in such a way that the King can not avoid death. This is the victory condition in Chess.
                    <br />
                    This level of moving your allies around like Chess pieces is a strong power fantasy for the player.
                </div>
            </p>
            <br />
        </div>
    )
}

export { LeadershipTier18DesignTemplate };